import TeamMemberService from 'services/TeamMemberService';
import { EXTERNAL_ACCOUNT, EXTERNAL_ACCOUNT_ALL } from '../query-keys';
import { useQuery } from '@tanstack/react-query';

export const toTeamMemberListOption = (tm) => {
  return {
    value: tm.id,
    label: tm.displayName,
    data: tm,
  };
};

export const useExternalAccountsCC = (rqOpts = {}, apiOpts = {}) => {
  return useQuery({
    queryKey: EXTERNAL_ACCOUNT.ALL,
    queryFn: () => TeamMemberService.getExternalAccountsCC(apiOpts),
    ...rqOpts,
  });
};

export const useExternalAccounts = (rqOpts = {}, apiOpts = {}) => {
  return useQuery({
    queryKey: EXTERNAL_ACCOUNT.ALL,
    queryFn: () => TeamMemberService.getExternalAccounts(apiOpts),
    ...rqOpts,
  });
};

export const useAllExternalAccountsCC = (opts, rqOpts = {}) => {
  return useQuery({
    queryKey: EXTERNAL_ACCOUNT_ALL.ALL,
    queryFn: () => TeamMemberService.getAllExternalAccountsCC(opts),
    ...rqOpts,
  });
};

export const updatePageConfigQuery = (key, config, objectId) => {
  if (objectId) {
    return TeamMemberService.updateCustomObjectRecordsListPageConfig(
      objectId,
      config
    );
  } else {
    return TeamMemberService.setPageConfig(key, config);
  }
};
